var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17050_6696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.98828 2.98828C6.30662 -0.330057 11.6934 -0.330057 15.0117 2.98828C18.3301 6.30662 18.3301 11.6934 15.0117 15.0117C11.6934 18.3301 6.30662 18.3301 2.98828 15.0117C-0.330057 11.6934 -0.330057 6.30662 2.98828 2.98828Z",
    stroke: "#47474A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97266 4.97687C7.97266 4.41527 8.44306 3.94727 9.00226 3.94727C9.56146 3.94727 10.0319 4.41767 10.0319 4.97687C10.0319 5.53607 9.57826 6.00647 9.00226 6.00647C8.42626 6.00647 7.97266 5.55287 7.97266 4.97687ZM8.04946 13.0529V7.85447C8.04946 7.24727 8.48866 6.85367 9.00466 6.85367C9.52066 6.85367 9.97426 7.24727 9.97426 7.85447V13.0529C9.97426 13.6601 9.53506 14.0537 9.00466 14.0537C8.47426 14.0537 8.04946 13.6601 8.04946 13.0529Z",
    fill: "#47474A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17050_6696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGrey);
export default __webpack_public_path__ + "static/media/info-grey.c90ffc0e6edc64781387119006b6b18d.svg";
export { ForwardRef as ReactComponent };